<template>
  <div class="download-select">
    <el-form :model="form" inline>
      <!-- 所属年份 -->
      <el-form-item :label="$t('prove_2')" required>
        <el-date-picker
          v-model="form.year"
          value-format="yyyy"
          type="year"
          :placeholder="$t('838')"
          :picker-options="pickerOptions"
        ></el-date-picker>
      </el-form-item>
      <!-- 员工信息 -->
      <el-form-item :label="$t('pay.slip.2')" >
        <el-input
          class="search-input"
          v-model="form.search_name"
          clearable
          :placeholder="`${$t('22')}、${$t('25')}、${$t('825')}`"
        ></el-input>
      </el-form-item>
      <!-- 部门 -->
      <el-form-item :label="$t('19')" >
        <Dep :change="changeDep" :mprop="{ checkStrictly: true }" />
      </el-form-item>
      <!-- 职位 -->
      <el-form-item :label="$t('24')">
        <el-select
          v-model="form.job_title_id"
          filterable
          remote
          reserve-keyword
          clearable
          :placeholder="$t('90')"
          :remote-method="remoteMethod"
        >
          <el-option v-for="item in posiOptions" :key="item.id" :label="item.job_title_name" :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <!-- 在职状态 -->
      <el-form-item :label="$t('31')">
        <el-select v-model="form.state" :placeholder="$t('799')" clearable multiple>
          <el-option
            v-for="(item, index) in sysInfoArr.state"
            :key="index"
            :label="item.value"
            :value="item.key"
          ></el-option>
        </el-select>
      </el-form-item>
      <!-- 离职日期 -->
      <el-form-item :label="$t('29')" v-if="form.state.includes('2') || form.state.includes('3')">
        <el-date-picker
          v-model="leaveDate"
          type="daterange"
          range-separator="-"
          :start-placeholder="$t('407')"
          :end-placeholder="$t('408')"
          clearable
          value-format="yyyy-MM-dd"
          @change="changeLeaveData"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <!-- 查询 -->
        <el-button type="primary" @click="search(1)">{{ $t('80') }}</el-button>
      </el-form-item>
    </el-form>
    <div class="download-btn">
      <span class="download-tip">{{ $t('prove_3', {x: isAll ? pageData.total : tableSelectArr.length}) }}</span>
      <el-button :disabled="!tableData.length" type="text" @click="onAllSelect">
        {{ $t('prove_4') }}
      </el-button>
      <!-- 批量下载 -->
      <el-button class="right" :disabled="!form.year || !tableSelectArr.length" type="text" @click="onDownload('download')">
        {{ $t('1884') }}
      </el-button>
      <!-- 批量发送 -->
      <el-button class="right" :disabled="!form.year  || !tableSelectArr.length" type="text" @click="onBatch('send')">
        {{ $t('prove_5') }}
      </el-button>
    </div>
    <!-- 列表 -->
    <div >
      <el-table :data="tableData" ref="table" @selection-change="tableSelectHandle" @select="onSelect" @select-all="onSelectAll">
        <el-table-column type="selection" width="65"></el-table-column>
        <template v-for="(item, key) in tableColumn">
          <!-- 个人邮箱 -->
          <template v-if="key === 'personal_email'">
            <el-table-column
              :key="item"
              :prop="key"
              :label="item"
              min-width="200px" />
          </template>
          <!-- 企业邮箱 -->
          <template v-else-if="key === 'enterprise_email'">
            <el-table-column
              :key="item"
              :prop="key"
              :label="item"
              min-width="200px" />
          </template>
          <el-table-column
            v-else
            :key="item"
            :prop="key"
            :label="item"
            :fixed="key === 'staff_name' ? 'left' : false"
            min-width="160px">
          </el-table-column>
        </template>
        <!-- 操作 -->
        <el-table-column :label="$t('70')" min-width="150" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" @click="onBatch('send', scope.row)">
              {{ $t('225') }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="pagaing-wrap">
        <el-pagination
          layout="total, sizes, prev, pager, next"
          :page-sizes="pageSizes"
          :current-page="form.page"
          :total="pageData.total"
          :page-size="form.page_size"
          @current-change="currentChangeHandle"
          @size-change="handleSizeChange"
        >
        </el-pagination>
      </div>
    </div>
    <el-dialog
      :visible.sync="visible"
      width="30%"
      @close="onClose">
      <p class="content">
        <label style="padding-right: 10px">{{ $t('1881') }}</label>
        <el-select v-model="emalType" :placeholder="$t('90')" @change="changeType">
          <el-option :label="$t('personal_email')" value="1"></el-option>
          <el-option :label="$t('business_mailbox')" value="2"></el-option>
          <el-option v-if="!!current" :label="$t('402')" value="3" ></el-option>
        </el-select>
      </p>
      <p class="content" v-if="!!current">
        <label style="padding-right: 10px">{{ $t('prove_9') }}</label>
        <el-input :disabled="emalType !== '3'" v-model="emailData[emalType]" :placeholder="$t('prove_8')"></el-input>
      </p>
      <template v-else>
        <p class="text" v-if="emalType" >{{ $t('prove_7', {x: current ? 1 : (isAll ? pageData.total : tableSelectArr.length), y: count, z: emalType === '1' ? $t('personal_email') : $t('business_mailbox')}) }}</p>
      </template>
      <template slot="footer">
        <el-button @click="onClose">{{ $t('66') }}</el-button>
        <el-button :disabled="current && !emailData[emalType]" type="primary" @click="onSubmit">{{ $t('131') }}</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
/**
 *  @description
 *  5 withholding tax certificate（50 Tawi)
 */
import { getAllListFn } from '@/api/org/position'
import { sysInfoFn } from '@/api/org/per'
import {
  getTawiList,
  countNoEmail,
  sendTawiMail,
  downloadTawiPdf
} from '@/api/payroll/prove-download'
import Dep from '@/components/department'
export default {
  components: {
    Dep
  },
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getFullYear() > new Date().getFullYear()
        }
      },
      leaveDate: [],
      form: {
        year: new Date().getFullYear().toString(),
        state: '', // 员工在职状态
        begin_leave_date: '', // 离职开始时间
        end_leave_date: '', // 离职结束时间
        search_name: '', // 员工信息
        job_title_id: '', // 职位id
        department_id: '', // 部门id
        page: 1,
        page_size: 20
      },
      pageSizes: [20, 50, 100],
      pageData: {},
      tableSelectArr: [],
      isAll: false,
      visible: false,
      count: 0,
      batchType: '',
      emalType: '',
      emailInfo: '',
      current: null,
      emailData: null,
      posiAllList: [],
      posiOptions: [],
      sysInfoArr: {
        state: [], // 在职状态
        salary_method: [], // 发薪方式
        settlement_type: [], // 结算类型
        formal: [] // 员工属性
      },
      tableData: [],
      tableColumn: []
    }
  },
  created() {
    this.getAllListFn()
    this.sysInfoFn()
  },
  methods: {
    async sysInfoFn() { // 获取员工状态
      const res = await sysInfoFn()
      if (res && res.code === 1) this.sysInfoArr = res.data
    },
    async getAllListFn() { // 获取职位数据
      const res = await getAllListFn()
      this.posiAllList = res.data
    },
    remoteMethod(query) { // 处理职位数据
      const obj = this.posiAllList.filter(v => v.job_title_name.toLowerCase().indexOf(query.toLowerCase()) > -1)
      this.posiOptions = query !== '' ? obj : []
    },
    changeDep(a) { // 获取部门id
      this.form.department_id = a[0] && a[0].department_id
    },
    changeLeaveData(v) { // 离职日期
      if (v) {
        this.form.begin_leave_date = v[0]
        this.form.end_leave_date = v[1]
      } else {
        this.form.begin_leave_date = ''
        this.form.end_leave_date = ''
      }
    },
    currentChangeHandle(val) {
      this.search(val)
    },
    handleSizeChange(val) {
      this.form.page_size = val
      this.search(1)
    },
    search(page) { // 查询
      this.form.page = page
      getTawiList(this.form).then(res => {
        if (res && res.code === 1) {
          this.tableColumn = res.data.header
          this.tableData = res.data.body
          this.pageData = res.data.page_data
          if (this.isAll) this.$refs.table.toggleAllSelection()
        } else {
          this.tableData = []
          this.tableColumn = []
          this.pageData = {}
        }
      })
    },
    onAllSelect() { // 选择全部
      this.isAll = true
      if (this.tableSelectArr.length !== this.tableData) {
        this.$refs.table.toggleAllSelection()
      }
    },
    tableSelectHandle(val) { // 表格选中
      this.tableSelectArr = val
    },
    onSelect(selection, row) {
      this.isAll = false
    },
    onSelectAll(selection, row) {
      if (!selection.length) this.isAll = false
    },
    onBatch(val, row) { // 批量发送/下载 打开弹窗
      this.visible = true
      this.batchType = val
      this.current = null
      this.emailData = null
      if (row) {
        this.current = row
        this.emailData = {
          1: this.current.personal_email,
          2: this.current.enterprise_email,
          3: ''
        }
      }
    },
    changeType() { // 多少人不能发送
      if (this.current) {
        const email = this.emalType === '1' ? !this.current.personal_email : !this.current.enterprise_email
        this.count = email ? 1 : 0
        return
      }
      if (this.isAll) {
        countNoEmail({ type: this.emalType }).then(res => {
          if (res && res.code === 1) {
            this.count = res.data
          } else {
            this.count = 0
          }
        })
      } else {
        const email = this.tableSelectArr.filter(item => {
          return this.emalType === '1' ? !item.personal_email : !item.enterprise_email
        })
        this.count = email.length
      }
    },
    onClose() {
      this.visible = false
      this.current = null
      this.emailData = null
      this.emalType = ''
    },
    onDownload() {
      const query = {
        year: this.form.year,
        staff_id: []
      }
      if (!this.isAll) {
        query.staff_id = this.tableSelectArr.map(item => {
          return item.staff_id
        })
      }
      downloadTawiPdf(query).then(res => {
        if (res && res.code === 1) {
          this.$message.success(res.message)
          this.tableSelectArr = []
          this.$refs.table.clearSelection()
          this.isAll = false
        }
      })
    },
    onSubmit() {
      const query = {
        year: this.form.year,
        type: this.emalType,
        staff_id: []
      }
      if (this.current) {
        query.staff_id = [this.current.staff_id]
        query.email = this.emailData[this.emalType]
      } else if (!this.isAll) {
        query.staff_id = this.tableSelectArr.map(item => {
          return item.staff_id
        })
      }
      sendTawiMail(query).then(res => {
        if (res && res.code === 1) {
          this.$message.success(res.message)
          if (!this.current) {
            this.tableSelectArr = []
            this.$refs.table.clearSelection()
            this.isAll = false
          }
          this.onClose()
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.download-btn {
  .download-tip {
    padding-right: 10px;
  }
  .right {
    float: right;
  }
}
.content {
  margin-bottom: 15px;
  padding-left: 30px;
  label {
    display: inline-block;
    width: 130px;
    text-align: right;
    padding-right: 10px;
  }
}
.text {
  text-align: center;
  font-size: 13px;
  color: red;
}
.no_data {
  padding: 100px;
  text-align: center;
}
.search-input {
  width: 320px;
  max-width: 320px;
}
</style>
